import { Typography, ButtonIcon } from '@statsbomb/kitbag-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useGetLinkPath from '@/hooks/useGetLinkPath';
import { visVideoLinkAtom } from '@/atoms/navigation';

export const VideoPlayerHeader = ({
  ids,
  title,
  allowFullScreen = true,
}: {
  title?: string;
  ids?: Record<string, string | number>;
  allowFullScreen?: boolean;
}) => {
  const { t } = useTranslation('general');
  const navigate = useNavigate();
  const { to, relative } = useGetLinkPath(visVideoLinkAtom, ids);

  return (
    <span className="flex items-center justify-between w-full">
      <Typography as="span" variant="headingMedium">
        {title}
      </Typography>
      {allowFullScreen && (
        <span className="hidden md:block ml-auto">
          <ButtonIcon title={t('fullScreen')} icon="Start" variant="ghost" onClick={() => navigate(to, { relative })} />
        </span>
      )}
    </span>
  );
};
